module.exports = __webpack_public_path__ + "img/icon-coupon-tag.ed68c2f2.svg";